module.exports = __webpack_public_path__ + "static/media/icon_note.7f8d920f.svg";